import React from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen';

import { ProductDetailsModalStockInfoSectionDefault, ProductDetailsModalStockInfoSectionDetails } from '.';

import styles from './ProductDetailsModalStockInfoSection.module.scss';

const ProductDetailsModalStockInfoSection = ({ hasTempData }: { hasTempData: boolean }) => {
  return (
    <div className={styles['product-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        상품 재고 정보
      </Text>

      <ProductDetailsModalStockInfoSectionDefault hasTempData={hasTempData} />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductDetailsModalStockInfoSectionDetails hasTempData={hasTempData} />
    </div>
  );
};

export default ProductDetailsModalStockInfoSection;
